import React from 'react'
import PropTypes from 'prop-types';
import Parent from 'pu-react/components/PriceMatrixCell'
import RadioComponent from 'pu-react/components/RadioComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

const show_icon = (restricted_price, row, col) => ((isManager && restricted_price !== undefined) ? restricted_price[row][col] : false);

// Overridden to make the quantity either a string or a number
class PriceMatrixCell extends Parent {
  showUnitPrice() {
    const additional = show_icon(this.props.restricted_price, this.props.row, this.props.col) ? <FontAwesomeIcon icon={faExclamationCircle} /> : null
    const price = `$${numeral(this.unitPrice()).format('0.00')}`
    return (
      <div className="d-flex gap-1 align-items-center">
        {additional} {price}
      </div>
    );
  }

  renderInput() {
    return (
      <RadioComponent
        inputId={`price-${this.identifier()}`}
        label={this.showUnitPrice()}
        name={this.props.name}
        onChange={this.onChange}
        inputClassName={this.props.inputClassName}
        checked={this.isSelected()}
        groupName="parameters[mx_pcb_assembly]" />
    );
  }
 }

PriceMatrixCell.propTypes = {
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default PriceMatrixCell
